import { useEffect, useRef } from 'react';
import { useFirmBaseLayoutContext } from './FirmBaseLayoutContext';
import type { FirmBaseLayoutNavigationRegistrationToken } from './FirmBaseLayoutContext.types';
import type { SecondaryNavigationContributionState } from './secondaryNavigationContribution.types';

export const useSecondaryNavigationContributionRegistration = (
  contribution: SecondaryNavigationContributionState | null
) => {
  const registrationTokenRef = useRef<FirmBaseLayoutNavigationRegistrationToken>(
    Symbol('secondary-navigation-contribution')
  );
  const registrationToken = registrationTokenRef.current;
  const { clearSecondaryNavigationContribution, registerSecondaryNavigationContribution } =
    useFirmBaseLayoutContext();

  useEffect(() => {
    registerSecondaryNavigationContribution(registrationToken, contribution);

    return () => {
      clearSecondaryNavigationContribution(registrationToken);
    };
  }, [clearSecondaryNavigationContribution, registerSecondaryNavigationContribution, registrationToken, contribution]);
};
